import QuestionCard from './components/question-card';
import QuestionComplete from './components/question-complete';
import QuestionError from './components/question-error';
import TermsAndConditions from './components/terms-and-conditions';
import { useSurveyContext } from './context/useSurveryContext';
import useService from './hooks/useService';
import { useSurveyFlow } from './hooks/useSurveyFlow';
import CustomButtonComponent from '../../components/custom-button/custom-button.component';
import styles from './styles/questions.module.css';

export default function Survey() {
	const { termsAccepted, completed, currentQuestion, loading } = useSurveyContext();
	const { isDisabled, handleContinue } = useSurveyFlow();
	useService();

	if (!termsAccepted) return <TermsAndConditions />;
	if (completed) return <QuestionComplete />;
	if (!currentQuestion) return <QuestionError />;
	//className="grid w-full gap-10"
	return (
		<div className={styles['div-question']}>
			<QuestionCard question={currentQuestion} />
			<div className={styles.btn}>
				<CustomButtonComponent
					id="btn-continue"
					label="Continuar"
					disabled={isDisabled}
					onClick={handleContinue}
					isLoading={loading}
					customStyles="btn-continuar "
				/>
			</div>
		</div>
	);
}
